'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { menuSearchInputMobileStateChange } from '../../actions/header/menu';
import { autocompleteIsVisibleSelector } from '../../reducers/autocomplete';
import { menuSearchInputMobileStateSelector } from '../../reducers/menu';
import { networkOnlineSelector } from '../../reducers/network';
import Menu from './components/Menu/Menu';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        searchInputActiveOnMobile: menuSearchInputMobileStateSelector(state),
        isListVisible: autocompleteIsVisibleSelector(state),
        networkOnline: networkOnlineSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toogleMenuSearchInputVisibility: (event) => {
            dispatch(menuSearchInputMobileStateChange());
            event.preventDefault();
        },
    };
};

class MenuContainer extends React.Component {
    render() {
        return <Menu {...this.props} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
